import React from 'react';
import { FiClock, FiPause } from 'react-icons/fi';
import { useTimeTracking } from '../context/TimeTrackingContext';

const GlobalTimeTracker = () => {
  const { isTracking, elapsedTime, projectName, taskTitle, stopTracking } = useTimeTracking();

  if (!isTracking) return null;

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg z-50 max-w-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <FiClock size={16} />
          <span className="font-mono font-bold">{formatTime(elapsedTime)}</span>
        </div>
        <button
          onClick={stopTracking}
          className="ml-2 p-1 hover:bg-green-600 rounded"
          title="Stop Tracking"
        >
          <FiPause size={14} />
        </button>
      </div>
      {(projectName || taskTitle) && (
        <div className="text-xs mt-1 opacity-90 truncate">
          {projectName && taskTitle ? `${projectName} - ${taskTitle}` : projectName || taskTitle}
        </div>
      )}
    </div>
  );
};

export default GlobalTimeTracker;